<template>
  <div>
    <div class="bigTitle">Qualitative</div>
    <div class="box">
      <div class="value physicians">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interviewbg.png" alt="">

        </div>
        <div class="title">In-Depth Interview (IDI)</div>
        <div class="text">
          <div class="one">
            In depth interviews (IDI) are conducted on a 1-on-1 bases. Participants in an IDI have more time to speak and react to questions and that helps acquire a deeper insight into the research subject.
          </div>
          <div class="two">
            An in-depth interview also allows the interviewer to give the participant full attention and our consultant can also adjust the interviewing style in order to get the most out of the interview.
          </div>
        </div>
        <div class="more" @click="toPath('/interview?source=webtable')">
          Find out more ＞
        </div>
      </div>
      <div class="value patient">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focuebg.png" alt="">

        </div>
        <div class="title">Focus Group / Traid / Duos</div>
        <div class="text">
          <div class="one">
            These methodologies bring a small group of target people together to answer designed questions. As a group, respondents can provide more nuanced and natural feedback. Group dynamics is powerful in the discovery process and leads to new ideas & new findings.

          </div>
          <!-- <div class="two">
            While we recommend that focus groups consist of eight respondents or less, Triads and Duos may be suggested as alternatives for generating ideas while allowing more time each respondent for in-depth questioning.
          </div> -->
        </div>
        <div class="more" @click="toPath('/focus?source=webtable')">
          Find out more ＞
        </div>
      </div>
      <div class="value consumer">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/ethnography/ethnographybg.png" alt="">

        </div>
        <div class="title">Ethnography</div>
        <div class="text">
          <div class="one">
            A qualitative approach that involves relative submersion into a particular community or organization to observe their behavior and interactions up close
          </div>
        </div>
        <div class="more" @click="toPath('/ethnography?source=webtable')">
          Find out more ＞
        </div>
      </div>
      <div class="value consumer">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/gangSurvey/surveybg.png" alt="">

        </div>
        <div class="title">Gang Survey</div>
        <div class="text">
          <div class="one">
            A hybrid methodology of qualitative and quantitative research methodologies. Part 1: a self-completed, standardized questionnaire is administered under moderator supervision. Every participant receives same instructions and information.
          </div>
          <div class="two">
             Part 2: A group discussion is held on the most important qualitative questions--based on their quantitative answers in Part 1.

          </div>
        </div>
        <div class="more" @click="toPath('/gangsurvey?source=webtable')">
          Find out more ＞
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bigTitle {
  font-size: 40px;
  padding: 10px 120px 0;
  font-weight: 700;
}
.box {
  display: flex;
  justify-content: space-between;
  margin: 20px 120px;
  .value {
    width: 24%;
  position: relative;

    // border: 1px solid #000;
    background-color: #2cb1e9;
    padding: 20px 20px 50px;
    color: #fff;
    .title {
      font-size: 20px;
      font-weight: 700;
    }
    .img {
      width: 150px;
      overflow: hidden;
      img {
        width: 300px;
        transform: translateX(-50%); /* 向左平移50%以显示右半边 */
      }
    }

    .text {
      .one,
      .two {
        margin-top: 10px;
      }
    }
    .more {
      // margin-top: 15px;
      position: absolute;
      bottom: 15px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .bigTitle{
    font-size: 80px;
  }
  .box{
    flex-wrap: wrap;
    .value{
      width: 100%;
      padding: 30px;
      margin-bottom: 20px;
      padding-bottom: 150px;
      .title{
        font-size: 75px;
      }
      .img{
        width: 500px;
        img{
          width: 1000px;
        }
      }
      .text{
        font-size: 70px;
      }
      .more{
        font-size: 70px;
      }
    }
  }
}
</style>